import { render, staticRenderFns } from "./AllInclusive.vue?vue&type=template&id=350bf91a&scoped=true&"
import script from "./AllInclusive.vue?vue&type=script&lang=js&"
export * from "./AllInclusive.vue?vue&type=script&lang=js&"
import style0 from "./AllInclusive.vue?vue&type=style&index=0&id=350bf91a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350bf91a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VCard,VCardText,VSwitch})
